import React, { useRef, useLayoutEffect } from 'react';
import html2canvas from 'html2canvas';
import PropTypes from 'prop-types';
import Link from '@src/mobile/components/Link';
import { isGrounds, shareAppWebCard } from '@src/public/utils/app';
import Image from './Image';
import Video from './Video';
import styles from './index.css';
import longLogo from '../../../assets/longLogo.png';
import iconFanzhuan from '../../../assets/fanzhuan.png';
import iconShichui from '../../../assets/shichui.png';
import watermark1 from '../../../assets/watermark1.png';
import watermark2 from '../../../assets/watermark2.png';
import watermark3 from '../../../assets/watermark3.png';
import BottomLogo from '../../../assets/bottomLogo.png';

const Card = ({ qrcode, content, timeline, handleShowShare }) => {
    const { description, link, img, video, milestone, watermark, longImg, title } = content;
    const { title: timelineTitle } = timeline;

    let desc = '';
    let imgList = img && Array.isArray(img) ? [...img] : [];

    if (longImg) {
        desc = title;
        imgList.unshift({ url: longImg });
    } else {
        desc = description || title;
    }

    const watermarkMap = new Map([[1, watermark1], [2, watermark2], [3, watermark3]]);

    const getMilestone = id => {
        switch (id) {
            case 1:
                return <img src={iconFanzhuan} alt="" className={styles.milestone} />;
            case 2:
                return <img src={iconShichui} alt="" className={styles.milestone} />;
            default:
                return null;
        }
    };

    const sourceRef = useRef();

    // 监听showShare，发生变化并且为true时调用端内分享自定义卡片的方法
    useLayoutEffect(() => {
        if (isGrounds && sourceRef.current) {
            html2canvas(sourceRef.current, { useCORS: true }).then(canvas => {
                const data = canvas.toDataURL('image/png');

                shareAppWebCard(data);
                handleShowShare(false);
            });
        }
    }, []);

    return (
        <div className={styles.wrap}>
            <div className={styles.source} ref={sourceRef}>
                <div className={styles.logoWrap}>
                    <div className={styles.logo}>
                        <img src={longLogo} alt="" />
                    </div>
                </div>
                <div className={styles.content}>
                    <div className={styles.desc}>
                        {getMilestone(milestone)}
                        <span className={styles.descText}>{desc}</span>
                        {link && (
                            <Link to={link.url} className={styles.descLink} style={{ color: '#3091f5' }}>
                                {link.title}
                            </Link>
                        )}
                        {watermarkMap.has(watermark) ? (
                            <div className={styles.watermark}>
                                <img src={watermarkMap.get(watermark)} alt="" />
                            </div>
                        ) : null}
                    </div>
                    {imgList.length ? (
                        <div className={styles.mediaWrap}>
                            <Image img={imgList.map(item => item.url)} />
                        </div>
                    ) : null}
                    {video && video.url ? (
                        <div className={styles.mediaWrap}>
                            <Video content={video} />
                        </div>
                    ) : null}
                    <div className={styles.info}>
                        <div className={styles.infoLeft}>
                            <div className={styles.qrcode}>
                                <img src={qrcode} alt="" />
                            </div>
                            <div className={styles.infoText}>
                                <div className={styles.infoTitle}>{timelineTitle}</div>
                                <div className={styles.infoIntro}>长按扫码，查看完整事件</div>
                            </div>
                        </div>
                        <div className={styles.infoRight}>
                            <div className={styles.bottomLogo}>
                                <img src={BottomLogo} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Card.propTypes = {
    qrcode: PropTypes.string,
    content: PropTypes.object,
    timeline: PropTypes.object,
    handleShowShare: PropTypes.func,
};

export default Card;
